import React from 'react';
import { unmountComponentAtNode } from "react-dom";
import Carousel from 'react-multi-carousel';
import ReactImageVideoLightBox from 'react-image-video-lightbox';
import { useState } from 'react'
import 'react-multi-carousel/lib/styles.css';


const CustomDot = ({ onClick, arrOfValues, ...rest }) => {
    const {
      onMove,
      index,
      active,
      carouselState: { currentSlide, deviceType }
    } = rest;
    // onMove means if dragging or swiping in progress.
    // active is provided by this lib for checking if the item is active or not.
    return (
      <button
        className={active ? "active carousel-dot" : "inactive carousel-dot"}
        onClick={() => onClick()}
      >
        <img src={arrOfValues[index]}></img>
      </button>
    );
  };

const destroyCarousel = () => {
  const carouselEl = document.getElementById('product-image-focus__block')
  if(carouselEl)
    unmountComponentAtNode(carouselEl);
}


const ProductImageSlider = ({ values, arrOfValues, responsive, selectedIndex }) => {
  
  const [open, setopen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const openlightbox = (index, e) => {
    e.preventDefault()
    setCurrentIndex(index);
    setopen(true);
  };  
  
    const dataForLightbox = []

    values.forEach(value => {
        if(value.image) {
          dataForLightbox.push({url: value.image.src, type: "photo", altTag:"image"})
        }
        if(value.video) {
          if(value.video.isYoutubeVideo) {
            dataForLightbox.push({url: `https://www.youtube.com/embed/${value.video.videoUrl}`, type: "video", altTag:"video"})
          }
          else {
            dataForLightbox.push({url: value.video.videoUrl, type: "video", altTag:"video"})
          }
        }
    });

    const isMultipleImages = values.length > 1;

  return (
    <div id="product-image-slider">
      {!open &&
      <div className='carousel-wrappe'>
        <Carousel 
        responsive={responsive}
        infinite={true}
        swipeable={isMultipleImages}
        draggable={isMultipleImages}
        showDots={isMultipleImages}
        arrows={isMultipleImages}
        customDot={<CustomDot arrOfValues={arrOfValues} />}>
            {values.map((value, index) => (
                <div className="outer-section" key={`figure${index}`}>
                  {value.image && <a href="" className="product-category__link"
                  >
                        <img onClick={() => openlightbox(index, event)} className="product-category__image" src={value.image.src}/>
                        </a> }
                  {value.video &&  value.video.isYoutubeVideo && <div className="video-responsive">
                        <iframe
                          width="853"
                          height="480"
                          src={`https://www.youtube.com/embed/${value.video.videoUrl}`}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          title="Embedded youtube"
                        />
                      </div>
                  }
                  {value.video && !value.video.isYoutubeVideo && 
                  <a href="" className="product-category__link">
                  <video className="product-category__image" src={value.video.videoUrl}/>
                  </a> }
                  
                  
                </div>
            ))}
        </Carousel>
      </div>
      }
      {open &&
      <div className="react-lightbox">
        <ReactImageVideoLightBox 
          data = {dataForLightbox}
          startIndex = {currentIndex}
          onCloseCallback={() => setopen(false)}
          onNavigationCallback={(currentIndex) =>
            console.log(`Current index: ${currentIndex}`)
          }
          />
          </div>
      }
      </div>
)};

export default ProductImageSlider;